<!--Start content -->
<header id="header">
    <div class="menu">
        <ul class="Cont_logo">
            <li class="logo">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve">
            <style type="text/css">
              .st0{fill:url(#XMLID_4_);}
              .st1{fill:url(#XMLID_5_);}
              .st2{fill:url(#XMLID_6_);}
              .st3{fill:url(#XMLID_7_);}
              .st4{fill:url(#XMLID_8_);}
              .st5{display:none;}
              .st6{display:inline;opacity:0.47;fill:#00FF00;}
            </style>
            <g id="Layer_1">
              <g id="XMLID_34_">
                <linearGradient id="XMLID_4_" gradientUnits="userSpaceOnUse" x1="22.8439" y1="250" x2="482.5133" y2="250">
                  <stop  offset="9.007122e-002" style="stop-color:#F05A2C"/>
                  <stop  offset="0.4226" style="stop-color:#EE5B2F;stop-opacity:0.9236"/>
                  <stop  offset="0.6261" style="stop-color:#E65F37;stop-opacity:0.8769"/>
                  <stop  offset="0.67" style="stop-color:#E3603A;stop-opacity:0.8668"/>
                  <stop  offset="1" style="stop-color:#DB6444;stop-opacity:0.82"/>
                </linearGradient>
                <path id="XMLID_3_" class="st0" d="M30.6,231L206.9,24c0.1-0.1,0.1-0.2,0.2-0.2l0,0l0,0c1.8-2.1,4.5-3.4,7.5-3.4h132.7
                  c2,0,3.9,0.6,5.4,1.6c0,0,1.6,1.1,3.3,3.7l121.8,142.6v0c0,0,4,5.1,4.6,8.3c0.9,5-3.6,9.8-8.8,9.8v0h0l-2.2,0l-128.5,0.1l-0.1-0.1
                  c-0.2,0-0.3,0-0.5,0c-3.6,0-7.1-3.5-9.1-6l-52.4-61.1L169.7,250l111.2,130.7l54.4-63.4l0,0c1.8-2.2,4.6-3.7,7.7-3.7l129.6-0.2
                  c5.4,0,9.9,4.4,9.9,9.9c0,3.7-2.1,7-5.1,8.6L355.9,475l-0.3-0.1c-1.7,2.8-4.8,4.7-8.4,4.7l-130.7-0.2c-0.7,0.2-1.4,0.2-2.2,0.2
                  c-4.2,0-7.9-2.7-9.2-6.4L29.3,267.3C29.3,267.3,14,250.6,30.6,231z"/>
                <linearGradient id="XMLID_5_" gradientUnits="userSpaceOnUse" x1="236.9782" y1="396.6115" x2="452.9728" y2="396.6115">
                  <stop  offset="9.007122e-002" style="stop-color:#F05A2C"/>
                  <stop  offset="0.4226" style="stop-color:#EE5B2F;stop-opacity:0.9236"/>
                  <stop  offset="0.6261" style="stop-color:#E65F37;stop-opacity:0.8769"/>
                  <stop  offset="0.67" style="stop-color:#E3603A;stop-opacity:0.8668"/>
                  <stop  offset="1" style="stop-color:#DB6444;stop-opacity:0.82"/>
                </linearGradient>
                <polygon id="XMLID_41_" class="st1" points="346.6,332.2 453,332.2 343.3,461.1 237,461.1 		"/>
                <linearGradient id="XMLID_6_" gradientUnits="userSpaceOnUse" x1="236.9782" y1="103.3909" x2="452.9728" y2="103.3909">
                  <stop  offset="9.007122e-002" style="stop-color:#F05A2C"/>
                  <stop  offset="0.4226" style="stop-color:#EE5B2F;stop-opacity:0.9236"/>
                  <stop  offset="0.6261" style="stop-color:#E65F37;stop-opacity:0.8769"/>
                  <stop  offset="0.67" style="stop-color:#E3603A;stop-opacity:0.8668"/>
                  <stop  offset="1" style="stop-color:#DB6444;stop-opacity:0.82"/>
                </linearGradient>
                <polygon id="XMLID_39_" class="st2" points="343.3,38.9 237,38.9 346.6,167.8 453,167.8 		"/>
                <linearGradient id="XMLID_7_" gradientUnits="userSpaceOnUse" x1="61.9165" y1="263.0705" x2="252.9781" y2="411.8874">
                  <stop  offset="0" style="stop-color:#F05A2C"/>
                  <stop  offset="0.1255" style="stop-color:#EE5B2C;stop-opacity:0.9035"/>
                  <stop  offset="0.1924" style="stop-color:#E65E2E;stop-opacity:0.852"/>
                  <stop  offset="0.2453" style="stop-color:#D86230;stop-opacity:0.8113"/>
                  <stop  offset="0.26" style="stop-color:#D36431;stop-opacity:0.8"/>
                  <stop  offset="0.4006" style="stop-color:#CC6031;stop-opacity:0.8427"/>
                  <stop  offset="0.7" style="stop-color:#C05A30;stop-opacity:0.9335"/>
                  <stop  offset="0.7849" style="stop-color:#BA572F;stop-opacity:0.9523"/>
                  <stop  offset="0.8964" style="stop-color:#AA4E2C;stop-opacity:0.977"/>
                  <stop  offset="1" style="stop-color:#944229"/>
                </linearGradient>
                <polygon id="XMLID_36_" class="st3" points="215.5,457.6 268.7,395.1 153.2,259.3 46.9,259.3 		"/>
                <linearGradient id="XMLID_8_" gradientUnits="userSpaceOnUse" x1="46.8509" y1="141.5607" x2="268.688" y2="141.5607">
                  <stop  offset="0" style="stop-color:#F05A2C"/>
                  <stop  offset="0.1255" style="stop-color:#EE5B2C;stop-opacity:0.9035"/>
                  <stop  offset="0.1924" style="stop-color:#E65E2E;stop-opacity:0.852"/>
                  <stop  offset="0.2453" style="stop-color:#D86230;stop-opacity:0.8113"/>
                  <stop  offset="0.26" style="stop-color:#D36431;stop-opacity:0.8"/>
                  <stop  offset="0.4006" style="stop-color:#CC6031;stop-opacity:0.8427"/>
                  <stop  offset="0.7" style="stop-color:#C05A30;stop-opacity:0.9335"/>
                  <stop  offset="0.7849" style="stop-color:#BA572F;stop-opacity:0.9523"/>
                  <stop  offset="0.8964" style="stop-color:#AA4E2C;stop-opacity:0.977"/>
                  <stop  offset="1" style="stop-color:#944229"/>
                </linearGradient>
                <polygon id="XMLID_43_" class="st4" points="215.5,42.4 268.7,104.9 153.2,240.7 46.9,240.7 		"/>
              </g>
            </g>
            <g id="Layer_2" class="st5">
              <path id="XMLID_2_" class="st6" d="M31,270c0,0-18.6-21,0-39H4l2.3,39H31z"/>
            </g>
            </svg>
            </li>
            <li class="name">
                <div>COMPROBANTES</div>
                <p>ONLINE</p>
            </li>
        </ul>
        <div class="Content-links">
            <ul id="main-nav">
                <li class="">
                    <a class="" href="#s1">
                Producto
              </a>
                </li>
                <li class="">
                    <a class="" href="#s2">
                Portal Clientes
              </a>
                </li>
                <li class="">
                    <a class="" href="#s3">
                Portal Proveedores
              </a>
                </li>
                <li class="">
                    <a class="" href="https://rpsistemas.com.ar/nosotros.php" target="blank">
                Contacto
              </a>
                </li>
                <li class="">
                    <a class="user_icon" href="#main">
                        <img src="assets/icon/user.svg">
                    </a>
                </li>
                <!--Boton flotante-->
                <li class="Btn">
                    <a href="#main">
                        <img src="assets/icon/arrow-up.svg">
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="menu_mobile">
        <div style="position:relative">
            <div class="top">
                <img src="assets/icon/icon_menu.svg" height="35" class="menu_btn" align="left" />
                <div class="logo_mobile">
                    <img src="assets/img/logo_comprobantes.png" />
                    <div class="title_mobile">COMPROBANTES ONLINE</div>
                </div>
            </div>

            <div id="grey_back">&nbsp;</div>

            <div id="menu_smartphone" class="menu_mobile_app">
                <ul id="main-nav" style="overflow-y:auto;">
                    <li>
                        <a href="#s1">
                Producto
              </a>
                    </li>
                    <li>
                        <a href="#s2">
                Portal Clientes
              </a>
                    </li>
                    <li>
                        <a href="#s3">
                Portal Proveedores
              </a>
                    </li>
                    <li>
                        <a href="https://rpsistemas.com.ar/contacto.php">
                Contacto
              </a>
                    </li>
                    <li class="contentUser_mobile">
                        <a class="user_icon" href="#main">
                            <img src="assets/icon/user.svg">
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</header>
<!--Sector Snap scroll-->
<div class="scrolSnap main-content">
    <!--Section 0 - Main-->
    <main id="main" class="">
        <div class="title">
            Acceda a sus Comprobantes
        </div>
        <div id="form_login" class="form_login">
            <div class="container">
                <form>
                    <div class="row">
                        <div class="col-12">
                            <input type="text" class="form-control" placeholder="CUIT o alias de su cliente o proveedor" [(ngModel)]="cuit_cliente" [ngModelOptions]="{standalone: true}" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <input type="text" class="form-control" placeholder="Su  CUIT/Usuario" [(ngModel)]="cuit_user" [ngModelOptions]="{standalone: true}" />
                        </div>
                        <div class="col-6">
                            <input type="password" class="form-control" placeholder="Contraseña" [(ngModel)]="password" [ngModelOptions]="{standalone: true}" />
                        </div>
                    </div>
                    <div class="content_CTA">
                        <button class="btn btn-primary" (click)="login()">Ingresar</button>
                        <div class="separador"></div>
                        <a (click)="recover()" class="hover">Olvidé mi contraseña</a>
                    </div>
                </form>
            </div>
        </div>
    </main>
    <!--Section 1 - Sistema-->
    <section id="s1" class="s1">
        <div>
            <img src="assets/img/img_s1.png">
        </div>
        <ul>
            <li class="s1_title">Sistema de gestión</li>
            <li class="s1_txt">
                Este sitio ofrece informacion de nuestro sistema de gestion ERP.
                <div>Para mas informacion ingrese a <strong><a href="https://rpsistemas.com.ar/" target="blank">aquí.</a></strong></div>
            </li>
            <li class="logo_rp">
                <a href="https://rpsistemas.com.ar/" target="blank">
                    <img src="assets/img/logo_rp.png">
                </a>
            </li>
        </ul>
    </section>
    <!--Section 2 - Portal Clientes-->
    <section id="s2" class="s2">
        <div class="container_boxes">
            <div class="box_info">
                <ul>
                    <li class="S_boxes_title">Portal de Clientes</li>
                    <li class="S_boxes_txt">Notifique a sus clientes sobre facturacion, pagos pendientes y recibos.</li>
                    <li class="S_boxes_icons">
                        <ul class="contentIcons_boxes">
                            <li>
                                <img src="assets/icon/icon_s2_1.svg">
                                <p>Módulo Facturas</p>
                            </li>
                            <li>
                                <img src="assets/icon/icon_s2_2.svg">
                                <p>Módulo Cuenta Corriente</p>
                            </li>
                            <li>
                                <img src="assets/icon/icon_s2_3.svg">
                                <p>Notificaciones Automáticas</p>
                            </li>
                            <li>
                                <img src="assets/icon/icon_s2_4.svg">
                                <p>Módulo Comunicaciones</p>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="box_img">
                <img src="assets/img/img_s2.png">
            </div>
        </div>
    </section>
    <!--Section 3 - Portal Proveedores-->
    <section id="s3" class="s3">
        <div class="container_boxes">
            <div class="box_info">
                <ul>
                    <li class="S_boxes_title">Portal de Proveedores</li>
                    <li class="S_boxes_txt">Disponibilidad on line de inforamación de pagos y estado de ordenes de compra.</li>
                    <li class="S_boxes_icons">
                        <ul class="contentIcons_boxes">
                            <li>
                                <img src="assets/icon/icon_s3_1.svg">
                                <p>Módulo documentos online</p>
                            </li>
                            <li>
                                <img src="assets/icon/icon_s3_2.svg">
                                <p>Módulo pagos</p>
                            </li>
                            <li>
                                <img src="assets/icon/icon_s3_3.svg">
                                <p>Módulo órdenes de compra</p>
                            </li>
                            <li>
                                <img src="assets/icon/icon_s3_4.svg">
                                <p>Módulo comunicaciones</p>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="box_img">
                <img src="assets/img/img_s3.png">
            </div>
        </div>
    </section>
    <!--Section 4 - Principales Caracteristicas-->
    <section id="s4" class="s4">
        <h1>Principales Características </h1>
        <ul class="contentIcons_s4">
            <li>
                <img src="assets/icon/icon_s4_1.svg">
                <p>Seguridad</p>
            </li>
            <li>
                <img src="assets/icon/icon_s4_2.svg">
                <p>Centralización</p>
            </li>
            <li>
                <img src="assets/icon/icon_s4_3.svg">
                <p>Disponibilidad</p>
            </li>
            <li>
                <img src="assets/icon/icon_s4_4.svg">
                <p>Soporte</p>
            </li>
        </ul>
    </section>
</div>
<footer>
    <div class="container_f1">
        <div class="f1_box1">
            <div class="logo_footer">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve">
            <style type="text/css">
              .st0{fill:url(#XMLID_4_);}
              .st1{fill:url(#XMLID_5_);}
              .st2{fill:url(#XMLID_6_);}
              .st3{fill:url(#XMLID_7_);}
              .st4{fill:url(#XMLID_8_);}
              .st5{display:none;}
              .st6{display:inline;opacity:0.47;fill:#00FF00;}
            </style>
            <g id="Layer_1">
              <g id="XMLID_34_">
                <linearGradient id="XMLID_4_" gradientUnits="userSpaceOnUse" x1="22.8439" y1="250" x2="482.5133" y2="250">
                  <stop  offset="9.007122e-002" style="stop-color:#F05A2C"/>
                  <stop  offset="0.4226" style="stop-color:#EE5B2F;stop-opacity:0.9236"/>
                  <stop  offset="0.6261" style="stop-color:#E65F37;stop-opacity:0.8769"/>
                  <stop  offset="0.67" style="stop-color:#E3603A;stop-opacity:0.8668"/>
                  <stop  offset="1" style="stop-color:#DB6444;stop-opacity:0.82"/>
                </linearGradient>
                <path id="XMLID_3_" class="st0" d="M30.6,231L206.9,24c0.1-0.1,0.1-0.2,0.2-0.2l0,0l0,0c1.8-2.1,4.5-3.4,7.5-3.4h132.7
                  c2,0,3.9,0.6,5.4,1.6c0,0,1.6,1.1,3.3,3.7l121.8,142.6v0c0,0,4,5.1,4.6,8.3c0.9,5-3.6,9.8-8.8,9.8v0h0l-2.2,0l-128.5,0.1l-0.1-0.1
                  c-0.2,0-0.3,0-0.5,0c-3.6,0-7.1-3.5-9.1-6l-52.4-61.1L169.7,250l111.2,130.7l54.4-63.4l0,0c1.8-2.2,4.6-3.7,7.7-3.7l129.6-0.2
                  c5.4,0,9.9,4.4,9.9,9.9c0,3.7-2.1,7-5.1,8.6L355.9,475l-0.3-0.1c-1.7,2.8-4.8,4.7-8.4,4.7l-130.7-0.2c-0.7,0.2-1.4,0.2-2.2,0.2
                  c-4.2,0-7.9-2.7-9.2-6.4L29.3,267.3C29.3,267.3,14,250.6,30.6,231z"/>
                <linearGradient id="XMLID_5_" gradientUnits="userSpaceOnUse" x1="236.9782" y1="396.6115" x2="452.9728" y2="396.6115">
                  <stop  offset="9.007122e-002" style="stop-color:#F05A2C"/>
                  <stop  offset="0.4226" style="stop-color:#EE5B2F;stop-opacity:0.9236"/>
                  <stop  offset="0.6261" style="stop-color:#E65F37;stop-opacity:0.8769"/>
                  <stop  offset="0.67" style="stop-color:#E3603A;stop-opacity:0.8668"/>
                  <stop  offset="1" style="stop-color:#DB6444;stop-opacity:0.82"/>
                </linearGradient>
                <polygon id="XMLID_41_" class="st1" points="346.6,332.2 453,332.2 343.3,461.1 237,461.1 		"/>
                <linearGradient id="XMLID_6_" gradientUnits="userSpaceOnUse" x1="236.9782" y1="103.3909" x2="452.9728" y2="103.3909">
                  <stop  offset="9.007122e-002" style="stop-color:#F05A2C"/>
                  <stop  offset="0.4226" style="stop-color:#EE5B2F;stop-opacity:0.9236"/>
                  <stop  offset="0.6261" style="stop-color:#E65F37;stop-opacity:0.8769"/>
                  <stop  offset="0.67" style="stop-color:#E3603A;stop-opacity:0.8668"/>
                  <stop  offset="1" style="stop-color:#DB6444;stop-opacity:0.82"/>
                </linearGradient>
                <polygon id="XMLID_39_" class="st2" points="343.3,38.9 237,38.9 346.6,167.8 453,167.8 		"/>
                <linearGradient id="XMLID_7_" gradientUnits="userSpaceOnUse" x1="61.9165" y1="263.0705" x2="252.9781" y2="411.8874">
                  <stop  offset="0" style="stop-color:#F05A2C"/>
                  <stop  offset="0.1255" style="stop-color:#EE5B2C;stop-opacity:0.9035"/>
                  <stop  offset="0.1924" style="stop-color:#E65E2E;stop-opacity:0.852"/>
                  <stop  offset="0.2453" style="stop-color:#D86230;stop-opacity:0.8113"/>
                  <stop  offset="0.26" style="stop-color:#D36431;stop-opacity:0.8"/>
                  <stop  offset="0.4006" style="stop-color:#CC6031;stop-opacity:0.8427"/>
                  <stop  offset="0.7" style="stop-color:#C05A30;stop-opacity:0.9335"/>
                  <stop  offset="0.7849" style="stop-color:#BA572F;stop-opacity:0.9523"/>
                  <stop  offset="0.8964" style="stop-color:#AA4E2C;stop-opacity:0.977"/>
                  <stop  offset="1" style="stop-color:#944229"/>
                </linearGradient>
                <polygon id="XMLID_36_" class="st3" points="215.5,457.6 268.7,395.1 153.2,259.3 46.9,259.3 		"/>
                <linearGradient id="XMLID_8_" gradientUnits="userSpaceOnUse" x1="46.8509" y1="141.5607" x2="268.688" y2="141.5607">
                  <stop  offset="0" style="stop-color:#F05A2C"/>
                  <stop  offset="0.1255" style="stop-color:#EE5B2C;stop-opacity:0.9035"/>
                  <stop  offset="0.1924" style="stop-color:#E65E2E;stop-opacity:0.852"/>
                  <stop  offset="0.2453" style="stop-color:#D86230;stop-opacity:0.8113"/>
                  <stop  offset="0.26" style="stop-color:#D36431;stop-opacity:0.8"/>
                  <stop  offset="0.4006" style="stop-color:#CC6031;stop-opacity:0.8427"/>
                  <stop  offset="0.7" style="stop-color:#C05A30;stop-opacity:0.9335"/>
                  <stop  offset="0.7849" style="stop-color:#BA572F;stop-opacity:0.9523"/>
                  <stop  offset="0.8964" style="stop-color:#AA4E2C;stop-opacity:0.977"/>
                  <stop  offset="1" style="stop-color:#944229"/>
                </linearGradient>
                <polygon id="XMLID_43_" class="st4" points="215.5,42.4 268.7,104.9 153.2,240.7 46.9,240.7 		"/>
              </g>
            </g>
            <g id="Layer_2" class="st5">
              <path id="XMLID_2_" class="st6" d="M31,270c0,0-18.6-21,0-39H4l2.3,39H31z"/>
            </g>
            </svg>
                <img class="logo_footer_mobile" src="assets/img/logo_comprobantes.png" />
            </div>
            <div class="name_footer">
                <img src="assets/img/logo_rp.png">
                <div>
                    <div>COMPROBANTES</div>
                    <p>ONLINE</p>
                </div>
            </div>
        </div>
        <div class="f1_box2">
            <ul>
                <li class="title_f1_box2">Nosotros</li>
                <li class="txt_f1_box2">
                    <a href="https://rpsistemas.com.ar/nosotros.php" target="blank">Acerca de nosotros</a>
                </li>
                <li class="txt_f1_box2">
                    <a href="https://rpsistemas.com.ar/contacto.php" target="blank">contacto</a>
                </li>
            </ul>
            <div>
                <a href="#main" class="cta_outline">
              Ingresar
            </a>
            </div>
        </div>
    </div>
    <div class="container_f2">
        <p></p>
        <ul>
            <li>Seguinos:</li>
            <li>
                <a href="https://www.linkedin.com/company/rpsistemas/" target="blank">
                    <img src="assets/icon/logo-linkedin.svg">
                </a>
            </li>
            <li>
                <a href="https://twitter.com/rpsistemasarg" target="blank">
                    <img src="assets/icon/logo-twitter.svg">
                </a>
            </li>
        </ul>
    </div>
</footer>